
/* eslint-disable react/default-props-match-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './spinner.module.scss';

const Spinner = ({ active, size, className, large }) => (
    large
      ? <>
      {active
        ? <div className={styles.showbox}>
          <div className={styles.loader}>
            <svg className={styles.circular} viewBox="25 25 50 50">
              <circle className={styles.path} cx="50" cy="50" r="20" fill="none" strokeWidth="2" strokeMiterlimit="10" />
            </svg>
          </div>
          </div> : '' }
        </>
      : <>
        <div className={`
  ${className}
  ${styles.spinner}
  ${active ? styles.active : ''}
`}
          style={{ width: size, height: size }}
        />
        </>
  );

Spinner.propTypes = {
  active: PropTypes.bool,
  size: PropTypes.string,
  className: PropTypes.string
};

Spinner.defaultProps = {
  active: false,
  size: '20px',
  className: '',
  large: false
};
export default Spinner;
